import { useLocation } from "react-router-dom";
import {
  doLogout,
  getDecodedTokenData,
  isAuthenticated,
} from "../common/utility";
import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import Header from "../components/molecules/Header";
import { connect } from "react-redux";
import Forbidden from "../pages/Forbidden";
import Env from "../Environments";
import moment from "moment";
import { Paths } from "../Routes/path";
import { fetchUserInfo } from "../api/UserAPI";
import store from "../redux/store";
import { setUserDetailsAction } from "../redux/actions/actions";

const Employee = ({ children, forbidden }) => {
  const { pathname } = useLocation();
  const { dispatch } = store;

  const getUserInfo = async () => {
    let data = await fetchUserInfo();
    dispatch(setUserDetailsAction(data.result));
  };

  useEffect(() => {
    !isAuthenticated() && doLogout();
    const tokenDecoded = getDecodedTokenData();
    Env.getGoogleAnalyticsEnabled() &&
      ReactGA.initialize(Env.getEmployeeGAMeasurementId(), {
        gaOptions: {
          userId: tokenDecoded.preferred_username,
          olm_id: tokenDecoded.preferred_username,
          user_name: tokenDecoded.name,
          login_date: moment().format("DD-MM-YYYY"),
        },
      });
    getUserInfo();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const page = Object.values(Paths).find((item) => item.path === pathname);
    page && (document.title = page.title);
  }, [pathname]);

  return (
    <>
      <Header />
      {!forbidden && children}
      {forbidden && <Forbidden />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    forbidden: state.forbidden,
  };
};

export default connect(mapStateToProps, null)(Employee);
